import React, { Component } from 'react'
import { Tab, Tabs } from "react-bootstrap";
import GoogleTab from './googleTab';
import { connect } from 'react-redux';
import NeedHelp from '../Elements/NeedHelp';
import { GET_FLITER_ID, getInitialRoute, showAddAccountAlertNew, isAppleSafari } from '../../../../../../utils';
import { MediaBaseUrl } from '../../../../../../actions/api';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import SearchPlace from './searchPlace';
import InfoSection from '../Elements/InfoSection';
import CheckBoxField from '../Elements/CheckboxField';
import { toast } from 'react-toastify';
import { createFeedAction, getConnectedAccount } from '../../../../../../actions/addFeedActions';
import { addUserAccount } from '../../../../../Authorization/SocialAuth/connectSocialAcc';

const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

class Googlefeed extends Component {
    state = {
        feedText: '',
        placeName: null,
        placeId: null,
        filterId: 33,
        filterType: 'Places',
        moderation: false,
        showError: false,
        connetedAccount: 0,
        accountChild: 0,
        loading: false,
        otherAccount: false
    }
    onModerationChange = (value) => this.setState({ moderation: value })
    onFieldTextChange = (text, id, placeName) => this.setState({ feedText: text, placeId: id, placeName: placeName, showError: false })
    onConnectedAccountChange = (value) => this.setState({ connetedAccount: value })
    onAccountChildChange = (value) => this.setState({ accountChild: value })
    onotherAccount = (value) => this.setState({ otherAccount: value })

    componentDidMount() {
        this.setState({ authRequired: this.props.feedInfo[0].authRequire })
        this.props.onFilterNameChange(this.state.filterType);
    }


    onSubmit = () => {
        const { feedText, placeId, filterType, accountChild, connetedAccount } = this.state;
        if (filterType == 'Places' && feedText == '') {
            this.setState({ showError: true });
        } else if(filterType == 'Places' && placeId == null){
            toast.error('Please select from dropdown', { autoClose: 3000 });
        }else {
            if (filterType == 'My Places' && (connetedAccount == 0 || accountChild == 0)) {
                toast.error('Need to connect google account', { autoClose: 3000 });
                return;
            }

            this.onAddFeed();
        }
    }


    onAddAccount = () => {
        showAddAccountAlertNew({id:4,name:"google"},"addFeed");
    }


    onAddFeed = () => {
        const { moderation, placeName, feedText, placeId, filterId, connetedAccount, accountChild } = this.state
        const { navigation, hideAddfeed, wallId } = this.props;

        var obj = {
            wallId: wallId,
            networkId: 4,
            filter: filterId,
            moderation: moderation ? 1 : 0,
            connetedAccount: 0,
            account: 0
        }
        if (filterId == 33) {
            obj['field33'] = feedText;
            obj['field33placeId'] = placeId
            obj['field33placeName'] = placeName
        } else if (filterId == 29) {
            obj['field33'] = '';
            obj['field33placeId'] = '';
            obj['field33placeName'] = '';
            obj['connetedAccount'] = connetedAccount;
            obj['account'] = accountChild;
        }

        this.setState({ showError: false, loading: true });
        createFeedAction(obj,4,(feedId)=>this.setState({loading:false},()=>{
            if(feedId){
                navigation(`/moderation/index/${wallId}`);
                hideAddfeed();
            }
        }))

    }

    needSupportLinks = (filterType) => {
        if (getInitialRoute() === 'widget') {
            switch (filterType) {
                case 'Places':
                    return ['https://vimeo.com/715480525', 'https://taggbox.com/support/add-google-reviews-using-taggbox-widget/']
                case 'My Places':
                    return ['https://vimeo.com/715480560', 'https://taggbox.com/support/add-google-reviews-using-taggbox-widget/']
                default:
                    return ['https://vimeo.com/715480525', 'https://taggbox.com/support/add-google-reviews-using-taggbox-widget/']
            }
        } else {
            switch (filterType) {
                case 'Places':
                    return ['https://vimeo.com/537158675/fd1ef53a3f', '']
                case 'My Places':
                    return ['https://vimeo.com/542107097/a260a59a02', '']
                default:
                    return ['https://vimeo.com/537158675/fd1ef53a3f', '']
            }
        }
    }

    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId,type } = response;
        if (type == "addFeed") {
        addUserAccount(networkId, data, () => this.props.getConnectedAccount(networkId),localStorage.getItem('ownerId'));
        }
    }

    componentDidMount() {
        channel.addEventListener("message", this.readAuthenticationCode);
    }

    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }

    render() {
        const { feedInfo, connectedAcc } = this.props;
        const { moderation, accountChild, connetedAccount, showError, otherAccount, filterType, loading, feedText } = this.state;
        var childAcc = connectedAcc && connectedAcc[0] && connectedAcc[0].ConnectedAccounts && connectedAcc[0].ConnectedAccounts.child && connectedAcc[0].ConnectedAccounts.child.length ? connectedAcc[0].ConnectedAccounts.child : '';

        return (
            <div className="form-body create_feed_wt">
                <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details createFeedInsta personalizePopup">
                    <Tabs defaultActiveKey="Places" id="GoogleFeedTab" className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3" onSelect={e => this.setState({ filterType: e, filterId: GET_FLITER_ID(e, feedInfo) }, () => this.props.onFilterNameChange(e))} >
                        <Tab eventKey={'Places'} key={'Places'} value="1" className="nav-link className= p-0" title={<span>{'Places'}</span>}>
                            <div className="form-group">
                                <SearchPlace onFieldTextChange={this.onFieldTextChange} setAddress={(e)=>this.setState({feedText:e, showError:false})} address={feedText}/>
                                {showError ? <span id="" className="errorMessage required">This field is required</span> : null}
                            </div>
                            <CheckBoxField isChecked={moderation} onChangeHandler={(e) => this.onModerationChange(e.target.checked)} name={"moderation"} id="checkbox_places" />
                            <InfoSection text="Initially the latest 5 user reviews of Place will be aggregated after which all the upcoming reviews will be aggregated." />
                        </Tab>
                        <Tab eventKey={'My Places'} key={'My Places'} value="1" className="nav-link className= p-0" title={<span>{'My Places'}</span>}>
                            {
                                (connectedAcc && connectedAcc.length > 0) ? 
                                <GoogleTab
                                    onAddAccount={this.onAddAccount}
                                    connectedAcc={connectedAcc}
                                    otherAccount={otherAccount}
                                    connetedAccount={connetedAccount}
                                    accountChild={accountChild}
                                    onotherAccount={this.onotherAccount}
                                    onAccountChildChange={this.onAccountChildChange}
                                    onConnectedAccountChange={this.onConnectedAccountChange}
                                    childAcc={childAcc}
                                /> : <div className="otherSection text-center">
                                    <div className="py-3">
                                        <a className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3">
                                            <span className="symbol symbol-25 me-3">
                                                <img src={`${MediaBaseUrl}social-icons/google.svg`} alt="" />
                                            </span>
                                            <span className="text-dark-50 font-weight-bolder font-size-base" onClick={this.onAddAccount}>Connect Google</span>
                                        </a>
                                    </div>
                                </div>
                            }
                            {!otherAccount ? <CheckBoxField isChecked={moderation} onChangeHandler={(e) => this.onModerationChange(e.target.checked)} name={"moderation"} id="checkbox_myplaces" /> : null}
                            <InfoSection text="Initially latest 50 user reviews will be aggregated after which all the upcoming reviews will be aggregated." />
                        </Tab>
                    </Tabs>
                </div>
                <div className="form-actions">
                    <div className="f-between flex-wrap border-top pt-3 mt-4">
                        <NeedHelp text={'Need help in adding feeds?'} videoUrl={this.needSupportLinks(filterType)[0]} supportLink={this.needSupportLinks(filterType)[1]} />
                        <SubmitFeedRequest onSubmit={this.onSubmit} onBack={this.props.onBack} loading={loading} hideBtn={(otherAccount && filterType == "My Places") || ( connectedAcc && connectedAcc.length == 0 && filterType == "My Places")}/>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        connectedAcc: state.addFeedReducer.connectedAcc
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getConnectedAccount: (networkId) => dispatch(getConnectedAccount(networkId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Googlefeed)
